// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
// @ts-nocheck
                        
import type * as SchemaTypes from '../index';

import { RbFragmentDoc, RingBuilderFragmentFragmentDoc, RingBuilderMountFragmentFragmentDoc, RingBuilderMountEngagementRingFragmentDoc, RingBuilderCentreStoneFragmentFragmentDoc } from '../ring-builder/rb.fragment.generated';
import { EngagementRingLinkFragmentDoc } from '../../../router/fragments/engagementRingLink.fragment.generated';
import { CatalogueEngagementRingInputFragmentDoc } from '../ring-builder/catalogueEngagementRingInput.fragment.generated';
import { MonolithImageSizeFragmentDoc } from '../../../components/useImageProps.generated';
import { RecommendedRingSizeFragmentDoc } from '../product/rings/fragments/recommendedRingSize.fragment.generated';
import { RingSizeFragmentDoc } from '../product/rings/fragments/ringSize.fragment.generated';
import { ProductPageMetaFragmentDoc } from '../../../views/product/composables/useProductPageMeta.generated';
import { AssetFragmentDoc } from '../fragments/asset.fragment.generated';
import { MetalFilterMetalFragmentDoc } from '../product/rings/fragments/filters/metalFilter.fragment.generated';
import { MoneyFragmentDoc } from '../fragments/money.fragment.generated';
import { SignatureStoneInputFragmentDoc } from '../product/rings/engagement/ring/fragments/signatureStoneInput.fragment.generated';
import { StoneFragmentDoc } from '../stone/gems/fragments/stone.fragment.generated';
import { StoneCategoryFragmentDoc } from '../stone/gems/fragments/StoneCategory.fragment.generated';
import { StoneCategoryTranslationFragmentDoc } from '../stone/gems/fragments/StoneCategoryTranslation.fragment.generated';
import { StoneClarityFragmentDoc } from '../stone/gems/fragments/stoneClarity.fragment.generated';
import { ClarityTranslationFragmentDoc } from '../stone/gems/fragments/ClarityTranslation.fragment.generated';
import { StoneColorFragmentDoc } from '../stone/gems/fragments/StoneColor.fragment.generated';
import { StoneColorTranslationFragmentDoc } from '../stone/gems/fragments/StoneColorTranslation.fragment.generated';
import { StoneCrystalFragmentDoc } from '../stone/nonsku/fragments/stoneCrystal.fragment.generated';
import { StoneCrystalTranslationFragmentDoc } from '../stone/nonsku/fragments/stoneCrystalTranslation.fragment.generated';
import { StoneImageFragmentDoc } from '../stone/gems/fragments/image.fragment.generated';
import { GemsApiCertificateFragmentDoc } from '../../../domain/stone/certificate.generated';
import { GemsApiStoneAnalyticsFragmentDoc, NonSkuGemstoneAnalyticsFragmentDoc, NonSkuLabGrownAnalyticsFragmentDoc } from '../../../views/product/composables/analytics/useProductAnalytics.generated';
import { NonSkuGemstoneFragmentDoc } from '../stone/nonsku/fragments/nonSkuGemstone.fragment.generated';
import { StoneShapeFragmentDoc } from '../stone/nonsku/fragments/stoneShape.fragment.generated';
import { StoneShapeTranslationFragmentDoc } from '../stone/nonsku/fragments/stoneShapeTranslation.fragment.generated';
import { StoneCutFragmentDoc } from '../stone/nonsku/fragments/stoneCut.fragment.generated';
import { StoneCutTranslationFragmentDoc } from '../stone/nonsku/fragments/stoneCutTranslation.fragment.generated';
import { StoneGradeFragmentDoc } from '../stone/nonsku/fragments/stoneGrade.fragment.generated';
import { NonSkuGemstoneImageFragmentDoc, NonSkuLabGrownStoneImageFragmentDoc } from '../../../domain/stone/useStoneImage.generated';
import { NonSkuLabGrownFragmentDoc } from '../stone/nonsku/fragments/nonSkuLabGrown.fragment.generated';
import { TaxSnippetFragmentDoc } from '../../../components/rings/TaxSnippet.generated';
import { AffirmFinanceOptionsFragmentDoc } from '../checkout/payment/affirmFinanceOptions.fragment.generated';
import * as Urql from '@/graphql/urql.ts';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;

export const RingBuilderResolveExistingCustomerDocument = `
    mutation ringBuilderResolveExistingCustomer($input: RingBuilderResolveInput!, $currency: CurrencyInput!, $country: CountryCode!, $locale: Locale!) {
  ringBuilderResolveExistingCustomer(input: $input) {
    __typename
    ... on RingBuilderResolvedExistingCustomerSuccess {
      ringBuilder {
        ...rb
      }
      redirect
    }
    ... on RingBuilderResolvedFailure {
      errors
    }
  }
}
    ${RbFragmentDoc}
${RingBuilderFragmentFragmentDoc}
${RingBuilderMountFragmentFragmentDoc}
${RingBuilderMountEngagementRingFragmentDoc}
${EngagementRingLinkFragmentDoc}
${CatalogueEngagementRingInputFragmentDoc}
${MonolithImageSizeFragmentDoc}
${RecommendedRingSizeFragmentDoc}
${RingSizeFragmentDoc}
${ProductPageMetaFragmentDoc}
${AssetFragmentDoc}
${MetalFilterMetalFragmentDoc}
${MoneyFragmentDoc}
${SignatureStoneInputFragmentDoc}
${RingBuilderCentreStoneFragmentFragmentDoc}
${StoneFragmentDoc}
${StoneCategoryFragmentDoc}
${StoneCategoryTranslationFragmentDoc}
${StoneClarityFragmentDoc}
${ClarityTranslationFragmentDoc}
${StoneColorFragmentDoc}
${StoneColorTranslationFragmentDoc}
${StoneCrystalFragmentDoc}
${StoneCrystalTranslationFragmentDoc}
${StoneImageFragmentDoc}
${GemsApiCertificateFragmentDoc}
${GemsApiStoneAnalyticsFragmentDoc}
${NonSkuGemstoneFragmentDoc}
${StoneShapeFragmentDoc}
${StoneShapeTranslationFragmentDoc}
${StoneCutFragmentDoc}
${StoneCutTranslationFragmentDoc}
${StoneGradeFragmentDoc}
${NonSkuGemstoneImageFragmentDoc}
${NonSkuLabGrownFragmentDoc}
${NonSkuLabGrownStoneImageFragmentDoc}
${NonSkuGemstoneAnalyticsFragmentDoc}
${NonSkuLabGrownAnalyticsFragmentDoc}
${TaxSnippetFragmentDoc}
${AffirmFinanceOptionsFragmentDoc}`;

export function useRingBuilderResolveExistingCustomerMutation() {
  return Urql.useMutation<SchemaTypes.RingBuilderResolveExistingCustomerMutation, SchemaTypes.RingBuilderResolveExistingCustomerMutationVariables>(RingBuilderResolveExistingCustomerDocument);
};